module.exports = __webpack_public_path__ + "static/img/9.d988919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/9.jpg
// module id = 9eT1
// module chunks = 0